import React, {useMemo} from "react";
import {useQueries} from "@tanstack/react-query";
import * as api from "../../api";
import TimeseriesHSComparisonGraph from "./TimeseriesHSComparisonGraph";
import {formatISO} from "date-fns";

const TimeseriesComparisonGraphs = ({stationIds, selectedFeatures, dateTimeGte, dateTimeLte, highlightedDate}) => {
    const ids = useMemo(() => {
        if (stationIds) return stationIds;
        if (selectedFeatures) return selectedFeatures.map(f => f.properties.id);
        return [];
    }, [stationIds, selectedFeatures]);

    const range = useMemo(() => {
        const rangeFilter = {};
        if (dateTimeGte) {
            rangeFilter.datetime__gte = formatISO(dateTimeGte);
        }
        if (dateTimeLte) {
            rangeFilter.datetime__lte = formatISO(dateTimeLte);
        }
        return rangeFilter;
    }, [dateTimeGte, dateTimeLte]);

    const comparisonDataQueries = useQueries({
        queries: (ids || []).map(id => ({
            queryKey: ['timeseries', 'stations', id, range],
            queryFn: () => api.Timeseries.getTimeseries(id, range),
            enabled: ids.length > 1,
        }))
    });

    const stations = useQueries({
        queries: (ids || []).map(id => ({
            queryKey: ['stations', id],
            queryFn: () => api.Station.getStation(id),
            enabled: ids.length > 1,
        }))
    });

    const comparisonData = useMemo(() => {
        const data = {};
        comparisonDataQueries.forEach((query, index) => {
            if (query.data) {
                const stationId = ids[index];
                data[stationId] = query.data.timestamps.map((ts, i) => ({
                    timestamp: ts,
                    hs: query.data.hs?.[i]
                }));
            }
        });
        return data;
    }, [comparisonDataQueries, ids.join("-")]);

    const stationsData = useMemo(() => {
        return (stations || []).map(q => q.data).filter(Boolean);
    }, [stations]);

    return (
        <TimeseriesHSComparisonGraph stationsData={comparisonData}
                                     stations={stationsData}
                                     highlightedDate={highlightedDate} />
    );
};

export default TimeseriesComparisonGraphs;
